import type { ContentStatus } from "@/lib/contentOps/statuses";
import type { BriefStatus } from "@/lib/contentOps/types";

// Sinai-style editorial labels mapped onto EGS's existing status enum.
// Pure presentation, does not mutate any data.
export type SinaiStatus =
  | "Not Started"
  | "Brief Ready"
  | "In Review"
  | "Approved"
  | "Draft Ready"
  | "Published";

export function toSinaiStatus(article: ContentStatus, brief?: BriefStatus | null): SinaiStatus {
  if (article === "published") return "Published";
  if (article === "ready" || article === "seo_review" || article === "human_review") return "Draft Ready";
  if (article === "draft") return "Draft Ready";
  if (article === "brief") {
    if (brief === "approved") return "Approved";
    if (brief === "in_review") return "In Review";
    if (brief === "rejected") return "Not Started";
    return "Brief Ready";
  }
  return "Not Started";
}

export const SINAI_META: Record<SinaiStatus, { color: string; bg: string }> = {
  "Not Started": { color: "hsl(0 0% 80%)",   bg: "hsl(0 0% 20%)" },
  "Brief Ready": { color: "hsl(265 80% 80%)", bg: "hsl(265 70% 55% / 0.22)" },
  "In Review":   { color: "hsl(38 95% 76%)",  bg: "hsl(38 92% 55% / 0.22)" },
  "Approved":    { color: "hsl(142 75% 74%)", bg: "hsl(142 70% 45% / 0.22)" },
  "Draft Ready": { color: "hsl(180 75% 76%)", bg: "hsl(180 70% 45% / 0.22)" },
  "Published":   { color: "hsl(142 65% 72%)", bg: "hsl(142 50% 35% / 0.24)" },
};
